export enum GeneralErrorTypes {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  INTERNET_ERROR = 'INTERNET_ERROR',
  ACCESS_ERROR = 'ACCESS_ERROR',
}
